import { render, staticRenderFns } from "./CoHorizontalBar.vue?vue&type=template&id=470457f4&"
import script from "./CoHorizontalBar.vue?vue&type=script&lang=ts&"
export * from "./CoHorizontalBar.vue?vue&type=script&lang=ts&"
import style0 from "./CoHorizontalBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
